import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../models';

@Pipe({
    name: 'customerName',
    standalone: true
})
export class CustomerNamePipe implements PipeTransform {
  transform(customer: Customer): any {
    if (customer.full_name) {
      return customer.full_name;
    }
    if (!customer.business) {
      let name = '';
      if (customer.first_name) {
        name = customer.first_name;
      }
      if (customer.last_name) {
        name += ' ' + customer.last_name;
      }
      return name.trim();
    }
    if (customer.business === 1) {
      return customer.business_name;
    }
  }
}
